import { RArray } from "../../collections";
import { makeImmutable } from "../../core";
export class SequentialCrossSellingListProvider {
    constructor(sequence) {
        this.sequence = sequence;
        makeImmutable(this);
    }
    items(inputProductTypeIds) {
        for (const provider of this.sequence) {
            const crossSellingItems = provider.items(inputProductTypeIds);
            if (!crossSellingItems.isEmpty) {
                return crossSellingItems;
            }
        }
        return RArray.empty();
    }
}
